import React from "react";

//UI Material
import {
  Card,
  Divider,
  Grid,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Delete } from "@mui/icons-material";

export default function ConnectivityDeviceLinkedStations({
  data,
  getDeviceData,
}) {
  return (
    <Card raised sx={{ height: "100%" }}>
      <Grid container sx={{ padding: "20px" }} spacing={1}>
        <Grid item xs={12} align="left">
          <Typography variant="h6" fontWeight="bold">
            Estaciones de carga vinculadas
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-start"
            spacing={1}
            sx={{ p: 2 }}
          >
            <Typography variant="h6" fontWeight="bold">
              {data.stations.length}
            </Typography>
            <Typography variant="h7">
              {`estaciones de carga vinculadas`}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Divider flexItem />
        </Grid>
        <Grid item xs={12}>
          <TableContainer>
            <Table aria-label="linked-stations-table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">
                    <Typography variant="body2" fontWeight="bold">
                      ID
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2" fontWeight="bold">
                      Acciones
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.stations.map((station) => (
                  <TableRow key={station}>
                    <TableCell align="center">
                      <Typography variant="body2">{station}</Typography>
                    </TableCell>
                    <TableCell align="center">
                      <IconButton>
                        <Delete color="error" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </Card>
  );
}
